import { render, staticRenderFns } from "./NewFollowBtn.vue?vue&type=template&id=3063f2e6&"
import script from "./NewFollowBtn.vue?vue&type=script&lang=js&"
export * from "./NewFollowBtn.vue?vue&type=script&lang=js&"
import style0 from "./NewFollowBtn.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports